import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { toast } from '@/lib/notify';
import { getApiErrorMessage, shouldSuppressToast } from './apiError';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    // Fires once after all retries are exhausted for a query.
    onError: (error) => {
      if (shouldSuppressToast(error)) return;
      toast.error(getApiErrorMessage(error));
    },
  }),

  mutationCache: new MutationCache({
    // Fires on every mutation failure (retry: 0 for mutations).
    onError: (error, _variables, _context, mutation) => {
      // Allow individual mutations to opt out via meta.suppressErrorToast.
      if ((mutation.meta as Record<string, unknown> | undefined)?.suppressErrorToast) return;
      if (shouldSuppressToast(error)) return;
      toast.error(getApiErrorMessage(error));
    },
  }),

  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
